import styled from "@emotion/styled";

export const StyledProductTitle = styled.div`
  min-width: 372px;
  padding: 12px 0 14px 16px;
  display: flex;
  gap: 16px;
  cursor: pointer;
  align-items: flex-start;
  flex-direction: column;

  .tab-title-text {
    display: flex;
    flex-direction: column;

    .product-title {
      font-weight: 500;
      line-height: 18px;
    }
  }

  .picture-component {
    img {
      width: 64px;
      object-fit: contain;
    }
  }

  .use-cases {
    margin-top: 2px;
    display: flex;
    gap: 8px;

    .use-case {
      font-size: 0.75rem;
      padding: 0 8px;
      color: var(--text-color);
      border-radius: 100px;
      border: 1px solid;
    }
  }
  .content-wrapper {
    display: flex;
    flex-direction: row;
    gap: 16px;
  }
`;
